var _rect, _path, _rect2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSpeed(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 66,
    height: 66,
    viewBox: "0 0 66 66",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 5,
    y: 5,
    width: 56,
    height: 56,
    rx: 28,
    fill: "#36BFFA"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M33.0002 26.0007V33.0007L37.6668 35.334M44.6668 33.0007C44.6668 39.444 39.4435 44.6673 33.0002 44.6673C26.5568 44.6673 21.3335 39.444 21.3335 33.0007C21.3335 26.5573 26.5568 21.334 33.0002 21.334C39.4435 21.334 44.6668 26.5573 44.6668 33.0007Z",
    stroke: "black",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 5,
    y: 5,
    width: 56,
    height: 56,
    rx: 28,
    stroke: "#B9E6FE",
    strokeWidth: 10
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSpeed);
export default __webpack_public_path__ + "static/media/Speed.fc007b577b5f6e1682db06c18f127683.svg";
export { ForwardRef as ReactComponent };